import { useState, useEffect } from 'react'
import { useAsyncOperation } from '../useAsyncOperation'
import { eventsAPI } from '../../services/api/events'
import { createLogger } from '../../utils/logger'

const logger = createLogger('useHomePageEvents')

/**
 * useHomePageEvents - Active pop-up events layer state for HomePageMap
 * @atomic @idempotent
 */
export function useHomePageEvents() {
  const [showEvents, setShowEvents] = useState(true)
  const [activeEvents, setActiveEvents] = useState([])
  const [eventParticipantIds, setEventParticipantIds] = useState(new Set())
  const { execute: loadEvents } = useAsyncOperation()

  useEffect(() => {
    loadEvents(() => eventsAPI.getActiveEvents(), {
      onSuccess: (res) => {
        const evts = res.data?.events || []
        setActiveEvents(evts)
        const ids = new Set(evts.flatMap(ev => (ev.participants || []).map(p => p.entityId)))
        setEventParticipantIds(ids)
      },
      onError: (err) => logger.warn('Failed to load events', err),
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return { showEvents, setShowEvents, activeEvents, eventParticipantIds }
}
